import { Tracking } from "root/libs/ui-containers/src";
import trackingContract from "./tracking-contract";

export const selectTrackingKey = Tracking.selectors.makeSelectTrackingKey(
  trackingContract
);
